<template>
    <div>
        <div class="advanced" :class="showAdvanced ? 'show' : 'hide'">
            <div class="row">
                <div class="col-12">
                    <SelectInput 
                        :value="value.completed"
                        @input="completed => $emit('input', { ...value, completed })"
                        :options="{ 1: $t('completed'), 0: $t('awaiting-response') }"
                        :indexIsValue="true"
                        :nullable="false"
                        :label="$t('filter-by-completed')"
                        :srOnly="true"
                    />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 d-flex flex-row align-items-center justify-content-between">
                <SearchBar v-model="value.search" placeholder="Search..." label="Search" />
                <button type="button" class="btn" :class="showAdvanced ? 'btn-primary' : 'btn-secondary'" @click="showAdvanced = !showAdvanced">{{ $t('advanced') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import SelectInput from "src/components/Inputs/SelectInput.vue"
import SearchBar from "src/components/Table/SearchBar.vue"

export default {
    components: {
        SelectInput,
        SearchBar,
    },
    props: {
        value: {
            type: Object,
            default: () => {
                return {
                    search: "",
                    completed: 1,
                }
            }
        },
        lockUser: Boolean   // If true, locks results to those owned by the user (as a student or as a teacher)
    },
    data() {
        return {
            showAdvanced: false,
        }
    },
    methods: {
        setDefaults() {
            const newVal = {
				search: "",
				completed: 1,
			}

            this.$emit('input', newVal)
		},
    },
}
</script>

<style lang="scss">
.advanced {
    transition: all 400ms ease-in-out;
}
.hide {
    max-height: 0;
    opacity: 0;
    pointer-events: none;
}
.show {
    max-height: 1000px;
    opacity: 1;
}
</style>